import React from 'react'
import '../../assets/style/validation.css'

import Text from "./Text"
import Logo from "../../assets/img/logo-bil.svg"
import query from '../../util/urlUtil'

const Validation = () => {
    return (
        <main id="main-validation-page">
            <div id="validation-content">
                <div align="center">
                    <img src={Logo} alt="Logo BIL" />
                </div>
                <Text value={query("status")} />
            </div>
        </main>
    );
}

export default Validation;